import type { CanvasJSONLikeObject, PolymorphicVariantDef } from '@doer/frontend-components/creativity-editor';
import { buildStoresGrid } from '../../_shared/images/stores-grid';

// participating-stores-text: solo en la variante "texto".
const storesText = (top: number): CanvasJSONLikeObject => ({
  pieceId: 'participating-stores-text',
  type: 'Textbox',
  version: '7.1.0',
  text: 'En comercios adheridos',
  fontFamily: 'VAG Rounded',
  fontSize: 43,
  fontWeight: 700,
  fontStyle: 'normal',
  lineHeight: 1.16,
  charSpacing: 0,
  textAlign: 'center',
  styles: [],
  fill: '#616365',
  originX: 'center',
  originY: 'center',
  left: 540,
  top,
  width: 685.7908,
  selectable: true,
  evented: true,
  objectCaching: true
});

// monthly-cap: va en ambas variantes con distinto top. pieceId distinto por variante:
// el binder no reposiciona una pieza ya montada, así que se montan/desmontan como piezas
// separadas (el valor persiste vía el sub-campo `monthly`).
const monthlyCap = (pieceId: string, top: number): CanvasJSONLikeObject => ({
  pieceId,
  type: 'Textbox',
  version: '7.1.0',
  text: 'Tope mensual: $10.000',
  fontFamily: 'VAG Rounded',
  fontSize: 32,
  fontWeight: 300,
  fontStyle: 'normal',
  lineHeight: 1.16,
  charSpacing: 0,
  textAlign: 'center',
  styles: [],
  fill: '#fe7606',
  originX: 'center',
  originY: 'center',
  left: 540,
  top,
  width: 499.314,
  selectable: true,
  evented: true,
  objectCaching: true
});

// Opción 1: texto "Comercios adheridos" + tope debajo.
const textVariant: PolymorphicVariantDef = {
  pieces: [storesText(1128.0646), monthlyCap('monthly-cap', 1176.2287)],
  bindings: [
    { pieceId: 'participating-stores-text', bindingType: 'text', from: 'stores' },
    { pieceId: 'monthly-cap', bindingType: 'text', from: 'monthly' }
  ]
};

// Opción 2: tope + grilla (sin texto de comercios). Posiciones placeholder — ajustar.
const gridVariant: PolymorphicVariantDef = {
  pieces: [
    // mismo top que "En comercios adheridos" en modo texto.
    monthlyCap('monthly-cap-grid', 1128.0646),
    buildStoresGrid({ position: { left: 540, top: 1242.7171, width: 720, height: 140 }, maxItemHeight: 42 })
  ],
  bindings: [{ pieceId: 'monthly-cap-grid', bindingType: 'text', from: 'monthly' }]
};

export const STORES_SECTION_VARIANTS = {
  text: textVariant,
  grid: gridVariant
};
